import toast from 'utils/toast'
import institutionAPI from 'services/institutionAPI'

export default async function markAllNotifiationsAsViewed() {
  const response = await institutionAPI({
    method: 'PATCH',
    url: '/notification/notification/notification/all-read',
  })

  if (!response?.header?.success) {
    toast.error(response?.header?.message)
  }

  return response
}
